import { formatBRL, formatBps } from '@deizi/shared';
import { decimalInput } from '../../../lib/numbers';

export const BANDEIRA_LABELS: Record<string, string> = {
  verde: 'Verde',
  amarela: 'Amarela',
  vermelha1: 'Vermelha 1',
  vermelha2: 'Vermelha 2',
};
export const TAX_MODE_LABELS: Record<string, string> = {
  fixed: 'Valor fixo (MEI)',
  percent: '% do faturamento',
};
export const ROUNDING_LABELS: Record<string, string> = {
  end_90: 'Termina em ,90',
  end_99: 'Termina em ,99',
  whole: 'Real inteiro',
  none: 'Sem arredondar',
};

/** Human value for the parameter history ("0,95", "30,00", "5%", "Verde"). */
export function formatSettingValue(param: string, value: unknown): string {
  if (value === null || value === undefined) return '—';
  const key = param.split('.')[1] ?? param;
  if (typeof value === 'number') {
    if (key.endsWith('PerKwh')) return `R$ ${decimalInput(value, 5, 2)}`;
    if (key.endsWith('Centavos')) return formatBRL(value);
    if (key.endsWith('Bps')) return formatBps(value);
    if (key === 'quoteValidityDays') return `${value} dias`;
    if (key === 'printHoursPerDay') return `${value} h/dia`;
    return String(value);
  }
  if (typeof value !== 'string') return JSON.stringify(value);
  if (key === 'bandeira') return BANDEIRA_LABELS[value] ?? value;
  if (key === 'taxMode') return TAX_MODE_LABELS[value] ?? value;
  if (key === 'rounding') return ROUNDING_LABELS[value] ?? value;
  return value;
}
